import { defineComponent as L, mergeModels as S, useModel as H, ref as u, computed as k, onBeforeMount as K, watch as f, openBlock as y, createBlock as V, normalizeClass as z, withCtx as c, createVNode as N, renderSlot as B, createElementBlock as U, Fragment as A, renderList as F, unref as W, createElementVNode as j } from "vue";
import q from "../BaseInput.js";
import { _ as G } from "./BaseDropDown.vue_vue_type_script_setup_true_lang.CLzTJaGp.js";
import "./js.cookie.CkZE2oaL.js";
import { _ as J } from "./SelectItem.vue_vue_type_script_setup_true_lang.Colhxc7n.js";
import { useKeyboardController as Q } from "../useKeyboardController.js";
function R(i, v) {
  return (...m) => new Promise((l, d) => {
    i.id && clearTimeout(i.id), i.id = setTimeout(() => {
      try {
        const a = v(...m);
        l(a);
      } catch (a) {
        d(a);
      }
    }, i.delay);
  });
}
const X = ["innerHTML"], oe = /* @__PURE__ */ L({
  __name: "BaseAutocomplete",
  props: /* @__PURE__ */ S({
    border: { type: Boolean, default: !0 },
    isValid: { default: null },
    theme: { default: "" },
    label: { default: "" },
    disableCb: { type: Boolean, default: !1 },
    onInputChangeCb: {},
    onOptionSelectedCb: { default: null },
    keepState: { default: null },
    cleanupOnClose: { type: Boolean, default: !0 },
    dropdownClasses: { default: "" },
    closeDropdownOnBodyPressed: { type: Boolean, default: !0 }
  }, {
    modelValue: {
      default() {
        return { id: "", label: "" };
      }
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ S(["update:dropdownState", "changedValue", "click", "keydown", "keydownEnterPressed"], ["update:modelValue"]),
  setup(i, { expose: v, emit: m }) {
    const l = i, d = H(i, "modelValue"), a = m, s = u(""), n = u([]), h = u(null), p = u(!1), o = u(!1), g = u(null), O = k(() => n.value.length);
    K(() => {
      h.value = R({ delay: 300 }, l.onInputChangeCb);
    });
    const { activeIdx: w, selectedIdx: C } = Q({
      optionsLength: O,
      isDropdownOpen: o,
      disableSpaceHandler: !0
    }), M = k(() => {
      switch (l.theme) {
        case "bordered":
          return "";
        case "all-bordered":
          return "!uikit-rounded " + (o.value && "!uikit-rounded-b-none");
        case "all-bordered-thick":
          return "!uikit-rounded-xl !uikit-h-[60px] " + (o.value && "!uikit-rounded-b-none");
        default:
          return "";
      }
    }), I = k(() => {
      switch (l.theme) {
        case "bordered":
          return "";
        case "all-bordered":
          return "uikit-border uikit-border-w-lavender uikit-border-solid !uikit-rounded !uikit-border-w-lavender !uikit-border " + (o.value ? "!uikit-border-b-0 !uikit-rounded-b-none" : "");
        case "all-bordered-thick":
          return "!uikit-rounded-xl !uikit-h-[60px] !uikit-border-w-lavender !uikit-border-none " + (o.value ? "!uikit-rounded-b-none" : "");
        default:
          return "";
      }
    }), P = k(() => {
      const e = "uikit-rounded-b-xl uikit-shadow uikit-rounded-t-none uikit-mb-0 !uikit-mt-0 uikit-text-w-black !uikit-rounded-b-xl !uikit-rounded-t-none";
      switch (l.theme) {
        case "bordered":
          return "before:uikit-content-[''] before:uikit-absolute before:uikit-w-1/2 before:uikit-border-b before:uikit-border-b-w-lavender before:[border-bottom-style:solid] before:uikit-right-1/4 uikit-rounded-b-xl uikit-shadow uikit-rounded-t-none uikit-mt-5px uikit-mb-0";
        case "all-bordered":
          return e;
        case "all-bordered-thick":
          return e + " !uikit-border-0";
        default:
          return "";
      }
    }), D = async (e) => {
      if (s.value !== e && (a("changedValue", e), s.value = e, !!l.onInputChangeCb)) {
        if (!e || p.value) {
          n.value = [], p.value = !1, C.value = -1, w.value = -1, d.value && (d.value.label = ""), o.value = !1, await h.value(null);
          return;
        }
        l.disableCb || (n.value = await h.value(e), o.value = !!n.value.length);
      }
    }, $ = (e, t) => {
      l.onOptionSelectedCb && l.onOptionSelectedCb(e), l.cleanupOnClose && (n.value = []), p.value = !0, s.value = e.label, d.value = e, o.value = !1, C.value = t;
    }, E = () => {
      n.value.length && l.keepState !== "closed" && (o.value = !0);
    };
    return f(
      d,
      (e, t) => {
        e !== t && (s.value = e?.label || "");
      },
      { immediate: !0 }
    ), f(C, (e) => {
      if (e === -1 || !n.value.length) return;
      const t = n.value[e];
      p.value && t.label === d.value?.label || $(t, e);
    }), f(
      () => l.keepState,
      (e) => {
        e === "closed" ? (o.value = !1, l.cleanupOnClose && (n.value = [])) : e === "open" && n.value.length && (o.value = !0);
      }
    ), f(o, (e) => {
      a("update:dropdownState", e);
    }), v({
      select: () => {
        g.value?.select();
      }
    }), (e, t) => (y(), V(G, {
      class: z(e.$attrs["root-classes"]),
      "data-cy": `ac_${e.$attrs.id}`,
      "dropdown-element": "ul",
      "dropdown-classes": [
        { "bordered-dropdown": e.theme === "bordered" },
        { "all-bordered-dropdown": e.theme === "all-bordered" },
        { "all-bordered-dropdown thick": e.theme === "all-bordered-thick" },
        {
          "uikit-mt-10px !uikit-border !uikit-border-w-secondary !uikit-rounded-xs": !e.theme
        },
        P.value,
        "!uikit-max-h-[210px] uikit-z-30",
        e.dropdownClasses
      ],
      "open-dropdown": o.value,
      "keep-state": !n.value.length || l.keepState === "closed" ? "closed" : "opened",
      "onUpdate:dropdownState": t[3] || (t[3] = (r) => o.value = r),
      onClick: t[4] || (t[4] = (r) => {
        a("click"), E();
      }),
      "close-when-clicked-outside": e.closeDropdownOnBodyPressed
    }, {
      btn_slot: c(() => [
        N(q, {
          id: `ac_input_${e.$attrs.id}`,
          ref_key: "baseInput",
          ref: g,
          "data-cy": `ac_input_${e.$attrs.id}`,
          "label-text": e.label,
          "model-value": s.value,
          "is-valid": e.isValid,
          disabled: e.$attrs.disabled,
          placeholder: e.$attrs.placeholder,
          "with-left-icon": !!e.$slots.lefticon,
          "with-right-icon": !!e.$slots.righticon,
          "input-class": [M.value, e.$attrs["input-classes"]],
          "fieldset-classes": [I.value, e.$attrs["fieldset-classes"]],
          "onUpdate:modelValue": t[0] || (t[0] = (r) => D(r === void 0 ? "" : `${r}`)),
          onKeydown: t[1] || (t[1] = (r) => a("keydown", r)),
          onKeydownEnterPressed: t[2] || (t[2] = () => a("keydownEnterPressed"))
        }, {
          leftIcon: c(() => [
            B(e.$slots, "lefticon")
          ]),
          righticon: c(({ handleClean: r }) => [
            B(e.$slots, "righticon", { handleClean: r })
          ]),
          _: 3
        }, 8, ["id", "data-cy", "label-text", "model-value", "is-valid", "disabled", "placeholder", "with-left-icon", "with-right-icon", "input-class", "fieldset-classes"])
      ]),
      default: c(() => [
        (y(!0), U(A, null, F(n.value, (r, b) => (y(), V(J, {
          key: b,
          active: W(w) === b,
          class: "uikit-m-1 uikit-rounded-[5px] uikit-px-5 uikit-py-10px hover:uikit-cursor-pointer",
          onClick: (T) => $(r, b),
          onMouseover: (T) => w.value = b
        }, {
          default: c(() => [
            j("span", {
              innerHTML: r.label
            }, null, 8, X)
          ]),
          _: 2
        }, 1032, ["active", "onClick", "onMouseover"]))), 128))
      ]),
      _: 3
    }, 8, ["class", "data-cy", "dropdown-classes", "open-dropdown", "keep-state", "close-when-clicked-outside"]));
  }
});
export {
  oe as _
};
